//recibo los datos que necesito para representarlos en la estadistica interacciones
// usando Firebase - Cloud Firestore

import * as firebase from 'firebase';
import { isArray } from 'util';
// import { QuerySnapshot } from '@google-cloud/firestore';

import Util from '../utils.js';

const database = firebase.firestore();

// function GetDatosInteracciones(){
    
//     let collRef = database.collection("sessions");

    // return collRef.get().then((coll) => {
    //     const promises = [];
        
    //     coll.docs.forEach((doc) => {
    //         promises.push(collRef.doc(doc.id).collection('history').get());
    //     });

    //     return Promise.all(promises);
    // }).then((data) => {
    //     let interacciones = 0;
//         let sesiones = 0;

//         const historial = [];
//         const intenciones = {};

//         data.forEach((coll) => {
//             sesiones++;
//             coll.docs.forEach((doc) => {
//                 const data = doc.data();

//                 interacciones++;
//                 historial.push(data);

//                 if(!intenciones[data.intent]){
//                     intenciones[data.intent] = 1;
//                 } else {
//                     intenciones[data.intent]++;
//                 }

//             });
//         });

//         const fallback = intenciones['Fallback'] / interacciones;

//         const labels = [];
//         const values = [];
//         for(const key in intenciones){
//             labels.push(key);
//             values.push(intenciones[key]);
//         }

//         return Promise.resolve({
//             interacciones, sesiones, fallback, labels, values
//         });
//     });

// }

    function GetDataSesiones(){
        let docRef = database.doc("graficos/sesiones");

        let sesiones = 0;

        return docRef.get().then((coll) => {
            const data = coll.data();

            for (const key in data) {
                sesiones = sesiones + data[key]
            }
            return sesiones;
        });
    }
    
    function GetDataFallBack(){
        let docRef = database.doc("graficos/intenciones");

        let totalIntents = 0;

        return docRef.get().then((coll) => {
            const datos = coll.data();

            for (const key in datos) {
                if(isArray(datos[key])){
                    totalIntents = totalIntents + datos[key][0];
                }else{
                    continue;
                }
            }
            return datos.Fallback[0] / totalIntents;
        });
    }

    function GetDataInteracciones(){
        let docRef = database.doc("graficos/intenciones");

        let totalIntents = 0;

        return docRef.get().then((coll) => {
            const datos = coll.data();

            for (const key in datos) {
                if(isArray(datos[key])){
                    totalIntents = totalIntents + datos[key][0]
                }else{
                    continue;
                }
            }
            
            return totalIntents;
        });
    }

    function GetDataGraficoInteracciones(){
        let docRef = database.doc("graficos/intenciones");

        const labels = [];
        const values = [];

        return docRef.get().then((coll) => {
            const intents = coll.data();

            for (const key in intents) {
                if(intents[key][1] !== 'Creditos'){
                    labels.push(key);
                    values.push(intents[key][0]);
                }else{
                    continue;
                }
            }
            
            return Promise.resolve({
                labels, values
            });
        });
    }

    function GetDataGraficoInteraccionesCreditos(){
        let docRef = database.doc("graficos/intenciones");

        const labels = [];
        const values = [];

        return docRef.get().then((coll) => {
            const intents = coll.data();

            for (const key in intents) {
                if(intents[key][1] === 'Creditos'){
                    labels.push(key);
                    values.push(intents[key][0]);
                }else{
                    continue;
                }
            }
            
            return Promise.resolve({
                labels, values
            });
        });
    }

    async function GetDataGraficoInteraccionesHora(fechaPeticion){
    
        let d = new Date();
        let mes = d.getMonth() + 1;

        const labels = ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'];

        const intentos = new Set();
        
        const dataSet = [];
        
        if(!fechaPeticion) fechaPeticion = ''+d.getDate()+'-'+mes+'-'+d.getFullYear()+'';

        const querySnapshot = await database.collection("graficos/").get();
        
        querySnapshot.forEach(doc => {
            const data = doc.data();
            if(doc.id === fechaPeticion){
                let i = 0;
                for (const key in data) {
                    for (const key2 in data[key]) {
                        intentos.add(key2);
                    }
                    i = i + 1;
                }

                for (const key in data) {
                    const dataCon = ['0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0'];
                    for (const iterator in data[key]) {
                        if(intentos.has(iterator)){
                            let index = dataSet.filter(x => x.label === iterator);                        
                            dataCon[key] = '' + data[key][iterator] + '';
                            if(index < 1){
                                let colorGrafico = Util.Color_aleatorio();
                                dataSet.push({ 
                                    label : iterator,
                                    data : [...dataCon],
                                    borderColor: colorGrafico,
                                    backgroundColor: colorGrafico,
                                    fill: false,
                                });
                            }else{
                                let pro = dataSet.find(x => x.label === iterator);
                                pro.data[key] = '' + data[key][iterator] + '';
                            }
                        }
                   }
                }
            }
        });
        // console.log(dataSet);
        
        return {labels,dataSet};
    }

export default {
    GetDataSesiones,
    GetDataFallBack,
    GetDataInteracciones,
    GetDataGraficoInteracciones,
    GetDataGraficoInteraccionesCreditos,
    GetDataGraficoInteraccionesHora,
};

